import { render, staticRenderFns } from "./OtherSchedule.vue?vue&type=template&id=67fefc30"
import script from "./OtherSchedule.vue?vue&type=script&lang=js"
export * from "./OtherSchedule.vue?vue&type=script&lang=js"
import style0 from "./OtherSchedule.vue?vue&type=style&index=0&id=67fefc30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports